import { useState } from 'react'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { Button, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useDataProvider } from 'react-admin'
import {
  TicketListGeneric,
  TicketEditGeneric,
  TicketCreateGeneric,
  TicketShowGeneric,
} from './tickets_generic'
import { compareProcesses } from './utils'
import Pill from './components/pill'
import { WidgetTicketKPI } from './components/dashboard_widget/ticket_kpi'
import config from './config'

const publicUrl = config.PUBLIC_URL

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  paperTitle: {
    color: theme.palette.text.primary,
  },
  item: {
    width: '300px',
  },
  icons: {
    width: '48px',
    margin: '8px 0',
  },
}))

export const TicketEditEP = (props) => {
  return <TicketEditGeneric {...props} />
}

export const TicketCreateEP = (props) => {
  return <TicketCreateGeneric {...props} />
}

export const TicketShowEP = (props) => <TicketShowGeneric {...props} />

const TicketListWrapper = (props) => {
  if (props.listmode === false) {
    return null
  }

  if (props.process !== null && props.process !== undefined) {
    if (props.starred === true) {
      return (
        <TicketListGeneric
          {...props}
          filter={{ process_id: props.process, starred: true, archived: false }}
          process_id={props.process}
        />
      )
    } else {
      return (
        <TicketListGeneric
          {...props}
          filter={{ process_id: props.process, archived: false }}
          process_id={props.process}
        />
      )
    }
  } else {
    if (props.starred === true) {
      return (
        <TicketListGeneric
          {...props}
          filter={{ starred: true, archived: false }}
          process_id={props.process}
        />
      )
    } else {
      return (
        <TicketListGeneric
          {...props}
          filter={{ archived: false }}
          process_id={props.process}
        />
      )
    }
  }
}

const KPIs = ({ data, res, listmode, process_id }) => {
  const classes = useStyles()

  if (res !== 'gestionnaire') {
    return null
  }
  if (listmode === true) {
    return null
  }
  return (
    <Grid container spacing={3}>
      <Grid item className={classes.item}>
        <Paper className={classes.paper}>
          <img
            className={classes.icons}
            src={`${publicUrl + `/img/icons/chart.svg`}`}
          />
          <Typography className={classes.paperTitle} gutterBottom>
            KPIs
          </Typography>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="subtitle2">
              % copros ticket prio créé &lt; 14mo
            </Typography>
            <Pill value={data.kpi1 || 'N/A'} status="success" size="small" />
          </Box>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="subtitle2">
              % avancement tickets prio
            </Typography>
            <Pill value={data.kpi2 || 'N/A'} status="success" size="small" />
          </Box>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="subtitle2">Dernière créa 5P</Typography>
            <Pill value={data.kpi3 || 'N/A'} status="success" size="small" />
          </Box>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="subtitle2">Visites prévues</Typography>
            <Pill value={data.kpi4 || 'N/A'} status="success" size="small" />
          </Box>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="subtitle2">Visites restantes</Typography>
            <Pill value={data.kpi5 || 'N/A'} status="success" size="small" />
          </Box>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="subtitle2">
              Nb copros visites à faire
            </Typography>
            <Pill value={data.kpi6 || 'N/A'} status="success" size="small" />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  )
}

const P5 = ({ data, setProcess, setStarred, setListmode, res, listmode }) => {
  const classes = useStyles()

  if (res !== 'gestionnaire') return null
  if (listmode === true) return null

  const handleClick = () => {
    setProcess(null)
    setStarred(true)
    setListmode(true)
  }

  return (
    <Grid container spacing={3}>
      <Grid item className={classes.item}>
        <Paper className={classes.paper} style={{ height: '271.594px' }}>
          <img
            className={classes.icons}
            src={`${publicUrl + `/img/icons/priority.svg`}`}
          />
          <Typography className={classes.paperTitle} gutterBottom>
            Dossiers prioritaires
          </Typography>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="body2" align="left">
              En cours
            </Typography>
            <Pill value={data.p1 || 'N/A'} status="success" size="small" />
          </Box>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="body2" align="left">
              À échéance &lt; 30 jours
            </Typography>
            <Pill value={data.p2 || 'N/A'} status="success" size="small" />
          </Box>
          <br />
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleClick()}
            disableElevation
          >
            Consulter
          </Button>
        </Paper>
      </Grid>
    </Grid>
  )
}

const TicketListEP = (props) => {
  const dataProvider = useDataProvider()
  const [data, setData] = useState([])
  const [sections, setSections] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [listmode, setListmode] = useState(false)
  const [process, setProcess] = useState(-1)
  const [starred, setStarred] = useState(false)

  if (loaded === false) {
    //We can't use list endpoint because api returns {data: ..., list: ...}
    //and List DataProvider does not like this structure
    dataProvider
      .getOne(props.res, { id: 1 })
      .then(({ data }) => {
        setData(data.data)
        setLoaded(true)
        setSections(computeSections(data.list))
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const classes = useStyles()

  const computeSections = (processes) => {
    var sections = {}
    processes.map((p) => {
      if (sections[p.tag] === undefined) {
        sections[p.tag] = [p]
      } else {
        sections[p.tag].push(p)
      }
    })
    var sections_names = Object.keys(sections)
    var sections_arr = []
    for (var k = 0; k < sections_names.length; k++) {
      var otherProcesses = sections[sections_names[k]]
      otherProcesses.sort(compareProcesses)
      sections_arr.push({
        section: sections_names[k],
        processes: otherProcesses,
      })
    }

    return sections_arr
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item>
          <KPIs {...props} data={data} listmode={listmode} />
        </Grid>
        <Grid item>
          <P5
            {...props}
            data={data}
            listmode={listmode}
            setListmode={setListmode}
            setProcess={setProcess}
            setStarred={setStarred}
          />
        </Grid>
      </Grid>

      {sections.map((s) => {
        if (listmode === true) return null

        return (
          <Grid container spacing={3}>
            <Grid item>
              <Typography variant="h5" style={{ color: 'grey' }} gutterBottom>
                {s.section}
              </Typography>
              <WidgetTicketKPI
                {...props}
                processes={s.processes}
                listmode={listmode}
                setListmode={setListmode}
                setProcess={setProcess}
                setStarred={setStarred}
              />
            </Grid>
          </Grid>
        )
      })}
      <TicketListWrapper
        {...props}
        listmode={listmode}
        setListmode={setListmode}
        process={process}
        starred={starred}
      />
    </div>
  )
}

export const TicketListPo = (props) => {
  return <TicketListEP {...props} res={'processowner'} />
}

export const TicketListGe = (props) => {
  return <TicketListEP {...props} res={'gestionnaire'} />
}
